// @ts-nocheck
import * as base from '../../base/realtime-session';
import type { server_Commands, server_Delete, server_Get, server_Post, server_Queries, server_Subscriptions } from '../../types/server/index';
import * as accountingCommandsModule from './modules/accounting/commands';
import * as analyticsCommandsModule from './modules/analytics/commands';
import * as automationCommandsModule from './modules/automation/commands';
import * as batchProcessesCommandsModule from './modules/batchProcesses/commands';
import * as billingCommandsModule from './modules/billing/commands';
import * as clientsManagementCommandsModule from './modules/clientsManagement/commands';
import * as defaultCommandsModule from './modules/default/commands';
import * as featureFlagsCommandsModule from './modules/featureFlags/commands';
import * as genericCommandsModule from './modules/generic/commands';
import * as identityCommandsModule from './modules/identity/commands';
import * as invoicingCommandsModule from './modules/invoicing/commands';
import * as itemsPublishingCommandsModule from './modules/itemsPublishing/commands';
import * as marketplaceHealthCommandsModule from './modules/marketplaceHealth/commands';
import * as mlAndAiCommandsModule from './modules/mlAndAi/commands';
import * as notificationsCommandsModule from './modules/notifications/commands';
import * as operationsCommandsModule from './modules/operations/commands';
import * as procurementCommandsModule from './modules/procurement/commands';
import * as salesCommandsModule from './modules/sales/commands';
import * as stockManagementCommandsModule from './modules/stockManagement/commands';
import * as systemsIntegrationsCommandsModule from './modules/systemsIntegrations/commands';
import * as identityDeleteModule from './modules/identity/delete';
import * as billingGetModule from './modules/billing/get';
import * as clientsManagementGetModule from './modules/clientsManagement/get';
import * as defaultGetModule from './modules/default/get';
import * as featureFlagsGetModule from './modules/featureFlags/get';
import * as genericGetModule from './modules/generic/get';
import * as identityGetModule from './modules/identity/get';
import * as invoicingGetModule from './modules/invoicing/get';
import * as itemsPublishingGetModule from './modules/itemsPublishing/get';
import * as systemsIntegrationsGetModule from './modules/systemsIntegrations/get';
import * as analyticsPostModule from './modules/analytics/post';
import * as automationPostModule from './modules/automation/post';
import * as billingPostModule from './modules/billing/post';
import * as defaultPostModule from './modules/default/post';
import * as featureFlagsPostModule from './modules/featureFlags/post';
import * as genericPostModule from './modules/generic/post';
import * as identityPostModule from './modules/identity/post';
import * as itemsPublishingPostModule from './modules/itemsPublishing/post';
import * as marketplaceHealthPostModule from './modules/marketplaceHealth/post';
import * as mlAndAiPostModule from './modules/mlAndAi/post';
import * as operationsPostModule from './modules/operations/post';
import * as salesPostModule from './modules/sales/post';
import * as systemsIntegrationsPostModule from './modules/systemsIntegrations/post';
import * as accountingQueriesModule from './modules/accounting/queries';
import * as analyticsQueriesModule from './modules/analytics/queries';
import * as automationQueriesModule from './modules/automation/queries';
import * as batchProcessesQueriesModule from './modules/batchProcesses/queries';
import * as billingQueriesModule from './modules/billing/queries';
import * as clientsManagementQueriesModule from './modules/clientsManagement/queries';
import * as defaultQueriesModule from './modules/default/queries';
import * as featureFlagsQueriesModule from './modules/featureFlags/queries';
import * as genericQueriesModule from './modules/generic/queries';
import * as identityQueriesModule from './modules/identity/queries';
import * as invoicingQueriesModule from './modules/invoicing/queries';
import * as itemsPublishingQueriesModule from './modules/itemsPublishing/queries';
import * as marketplaceHealthQueriesModule from './modules/marketplaceHealth/queries';
import * as mlAndAiQueriesModule from './modules/mlAndAi/queries';
import * as notificationsQueriesModule from './modules/notifications/queries';
import * as operationsQueriesModule from './modules/operations/queries';
import * as procurementQueriesModule from './modules/procurement/queries';
import * as salesQueriesModule from './modules/sales/queries';
import * as stockManagementQueriesModule from './modules/stockManagement/queries';
import * as systemsIntegrationsQueriesModule from './modules/systemsIntegrations/queries';
import * as accountingSubscriptionsModule from './modules/accounting/subscriptions';
import * as analyticsSubscriptionsModule from './modules/analytics/subscriptions';
import * as automationSubscriptionsModule from './modules/automation/subscriptions';
import * as batchProcessesSubscriptionsModule from './modules/batchProcesses/subscriptions';
import * as billingSubscriptionsModule from './modules/billing/subscriptions';
import * as clientsManagementSubscriptionsModule from './modules/clientsManagement/subscriptions';
import * as defaultSubscriptionsModule from './modules/default/subscriptions';
import * as featureFlagsSubscriptionsModule from './modules/featureFlags/subscriptions';
import * as genericSubscriptionsModule from './modules/generic/subscriptions';
import * as identitySubscriptionsModule from './modules/identity/subscriptions';
import * as invoicingSubscriptionsModule from './modules/invoicing/subscriptions';
import * as itemsPublishingSubscriptionsModule from './modules/itemsPublishing/subscriptions';
import * as notificationsSubscriptionsModule from './modules/notifications/subscriptions';
import * as operationsSubscriptionsModule from './modules/operations/subscriptions';
import * as procurementSubscriptionsModule from './modules/procurement/subscriptions';
import * as salesSubscriptionsModule from './modules/sales/subscriptions';
import * as stockManagementSubscriptionsModule from './modules/stockManagement/subscriptions';
import * as systemsIntegrationsSubscriptionsModule from './modules/systemsIntegrations/subscriptions';

export type * from '../../types/server/index';

export type ClientLibraryType = ReturnType<typeof create>;

export const create = ( params: base.BackendConfig, fetch?: any, headers?: Record<string, string | undefined>, contextProvider?: base.ExecutionContextProvider ) => {
  const req = base.requests( params, fetch, headers, contextProvider );
  const buildCommands = (): server_Commands => ({
    ...accountingCommandsModule.createCommands( req ),
    ...analyticsCommandsModule.createCommands( req ),
    ...automationCommandsModule.createCommands( req ),
    ...batchProcessesCommandsModule.createCommands( req ),
    ...billingCommandsModule.createCommands( req ),
    ...clientsManagementCommandsModule.createCommands( req ),
    ...defaultCommandsModule.createCommands( req ),
    ...featureFlagsCommandsModule.createCommands( req ),
    ...genericCommandsModule.createCommands( req ),
    ...identityCommandsModule.createCommands( req ),
    ...invoicingCommandsModule.createCommands( req ),
    ...itemsPublishingCommandsModule.createCommands( req ),
    ...marketplaceHealthCommandsModule.createCommands( req ),
    ...mlAndAiCommandsModule.createCommands( req ),
    ...notificationsCommandsModule.createCommands( req ),
    ...operationsCommandsModule.createCommands( req ),
    ...procurementCommandsModule.createCommands( req ),
    ...salesCommandsModule.createCommands( req ),
    ...stockManagementCommandsModule.createCommands( req ),
    ...systemsIntegrationsCommandsModule.createCommands( req )
  });
  let commandsCache: server_Commands | undefined;
  const buildDelete = (): server_Delete => ({
    ...identityDeleteModule.createDelete( req )
  });
  let deleteCache: server_Delete | undefined;
  const buildGet = (): server_Get => ({
    ...billingGetModule.createGet( req ),
    ...clientsManagementGetModule.createGet( req ),
    ...defaultGetModule.createGet( req ),
    ...featureFlagsGetModule.createGet( req ),
    ...genericGetModule.createGet( req ),
    ...identityGetModule.createGet( req ),
    ...invoicingGetModule.createGet( req ),
    ...itemsPublishingGetModule.createGet( req ),
    ...systemsIntegrationsGetModule.createGet( req )
  });
  let getCache: server_Get | undefined;
  const buildPost = (): server_Post => ({
    ...analyticsPostModule.createPost( req ),
    ...automationPostModule.createPost( req ),
    ...billingPostModule.createPost( req ),
    ...defaultPostModule.createPost( req ),
    ...featureFlagsPostModule.createPost( req ),
    ...genericPostModule.createPost( req ),
    ...identityPostModule.createPost( req ),
    ...itemsPublishingPostModule.createPost( req ),
    ...marketplaceHealthPostModule.createPost( req ),
    ...mlAndAiPostModule.createPost( req ),
    ...operationsPostModule.createPost( req ),
    ...salesPostModule.createPost( req ),
    ...systemsIntegrationsPostModule.createPost( req )
  });
  let postCache: server_Post | undefined;
  const buildQueries = (): server_Queries => ({
    ...accountingQueriesModule.createQueries( req ),
    ...analyticsQueriesModule.createQueries( req ),
    ...automationQueriesModule.createQueries( req ),
    ...batchProcessesQueriesModule.createQueries( req ),
    ...billingQueriesModule.createQueries( req ),
    ...clientsManagementQueriesModule.createQueries( req ),
    ...defaultQueriesModule.createQueries( req ),
    ...featureFlagsQueriesModule.createQueries( req ),
    ...genericQueriesModule.createQueries( req ),
    ...identityQueriesModule.createQueries( req ),
    ...invoicingQueriesModule.createQueries( req ),
    ...itemsPublishingQueriesModule.createQueries( req ),
    ...marketplaceHealthQueriesModule.createQueries( req ),
    ...mlAndAiQueriesModule.createQueries( req ),
    ...notificationsQueriesModule.createQueries( req ),
    ...operationsQueriesModule.createQueries( req ),
    ...procurementQueriesModule.createQueries( req ),
    ...salesQueriesModule.createQueries( req ),
    ...stockManagementQueriesModule.createQueries( req ),
    ...systemsIntegrationsQueriesModule.createQueries( req )
  });
  let queriesCache: server_Queries | undefined;
  const buildSubscriptions = (): server_Subscriptions => ({
    ...accountingSubscriptionsModule.createSubscriptions( req ),
    ...analyticsSubscriptionsModule.createSubscriptions( req ),
    ...automationSubscriptionsModule.createSubscriptions( req ),
    ...batchProcessesSubscriptionsModule.createSubscriptions( req ),
    ...billingSubscriptionsModule.createSubscriptions( req ),
    ...clientsManagementSubscriptionsModule.createSubscriptions( req ),
    ...defaultSubscriptionsModule.createSubscriptions( req ),
    ...featureFlagsSubscriptionsModule.createSubscriptions( req ),
    ...genericSubscriptionsModule.createSubscriptions( req ),
    ...identitySubscriptionsModule.createSubscriptions( req ),
    ...invoicingSubscriptionsModule.createSubscriptions( req ),
    ...itemsPublishingSubscriptionsModule.createSubscriptions( req ),
    ...notificationsSubscriptionsModule.createSubscriptions( req ),
    ...operationsSubscriptionsModule.createSubscriptions( req ),
    ...procurementSubscriptionsModule.createSubscriptions( req ),
    ...salesSubscriptionsModule.createSubscriptions( req ),
    ...stockManagementSubscriptionsModule.createSubscriptions( req ),
    ...systemsIntegrationsSubscriptionsModule.createSubscriptions( req )
  });
  let subscriptionsCache: server_Subscriptions | undefined;

  return {
    setBearerToken: req.setBearerToken,
    ...base.getCustomExports(),
    get commands() {
      if ( !commandsCache ) {
        commandsCache = buildCommands();
      }
      return commandsCache;
    },
    get delete() {
      if ( !deleteCache ) {
        deleteCache = buildDelete();
      }
      return deleteCache;
    },
    get get() {
      if ( !getCache ) {
        getCache = buildGet();
      }
      return getCache;
    },
    get post() {
      if ( !postCache ) {
        postCache = buildPost();
      }
      return postCache;
    },
    get queries() {
      if ( !queriesCache ) {
        queriesCache = buildQueries();
      }
      return queriesCache;
    },
    get subscriptions() {
      if ( !subscriptionsCache ) {
        subscriptionsCache = buildSubscriptions();
      }
      return subscriptionsCache;
    }
  };
};

export { serverClientOperations } from './operations';
export type { ServerClientCommandName } from './operations';
